import Swiper, { FreeMode, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper';
import 'swiper/css';

function initialize() {
    const swiperThumbs = new Swiper('.gallery .swiper-gallery', {
        modules: [Navigation, Pagination, FreeMode, Thumbs, Scrollbar],
        slidesPerView: 1,
        watchSlidesProgress: true,

        pagination: {
            el: '.gallery .swiper-gallery .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });

    new Swiper('.gallery .swiper-gallery', {
        modules: [Navigation, Pagination, FreeMode, Thumbs],

        thumbs: {
            swiper: swiperThumbs,
        },

        navigation: {
            prevEl: '.gallery .swiper-gallery .btn-prev',
            nextEl: '.gallery .swiper-gallery .btn-next',
        },
    });

    $('.gallery .wrap-modal-video').on('click', function () {
        hideModalVideo();
    });

    $('.gallery .btn-video').on('click', function () {
        showModalVideo($(this).data('video'));
    });
}

function hideModalVideo() {
    $('.wrap-modal-video').css('opacity', 0);
    $('.wrap-modal-video').css('visibility', 'hidden');
    $('.wrap-modal-video .modal-content').empty();
}

function showModalVideo(videoId) {
    $('.wrap-modal-video').css('opacity', 1);
    $('.wrap-modal-video').css('visibility', 'visible');

    $('.wrap-modal-video')
        .find('.modal-content')
        .html(
            '<iframe class="w-full h-full" src="https://www.youtube.com/embed/' +
                videoId +
                '?rel=0&autoplay=1&controls=2&modestbranding=1&playsinline=1&showinfo=0" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
}

initialize();
